<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Schedule for '{{inner_expert_title}}' on '{{inner_persianDate}}'</h5>
    <form>

      <div class="row">
        <div class="form-group col-md-8">
          <label for="exampleInputEmail1">Description</label>
          <input type="text" [(ngModel)]="Dsc" name="Dsc" class="form-control" placeholder="Type here...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Type Program</label>
          <select [(ngModel)]="Type_id" name="Type_id" class="custom-select">
            <option value="0">Routine Action</option>
            <option value="2">Initial Scheduling</option>
            <option value="3">Approve Customer</option>
            <option value="4">Mission Reservation</option>
            <option value="5">Final Approval</option>
            <option value="6">Certificate Typing</option>
            <option value="7">Special Conditions</option>
          </select>
        </div>
      </div>

      <br/>
      <br/>

      <div class="table-responsive" *ngIf="DataList_Selected_Schedules.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
              <th>Last Action</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Selected_Schedules">
              <td>{{DataList_Selected_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>
              <td>
                <p *ngIf="item.coordination==-1" style="color:blue ;">In Progress</p>
                <p *ngIf="item.coordination==1" style="color:green ;">Coordinated</p>
                <p *ngIf="item.coordination==0" style="color:red ;">Not Coordinated</p>

                <p *ngIf="item.done==1" style="color:green ;">Completed</p>
                <p *ngIf="item.done==0" style="color:red ;">Not Canceled</p>
              </td>
              <td>{{item.activity_date}}</td>
              <td>
                <button ype="button" (click)="delete_hokem(DataList_Selected_Schedules.indexOf(item))" class="btn btn-danger">Delete Mission</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <br/>
      <br/>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button" (click)="openModal(templateHokem)" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Select Decree </button>
      <button *ngIf="!InProccessing" type="button" (click)="Submit()" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button (click)="On_Back()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
    </form>

    <br/>
    <hr/>
    <br/>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Description</th>
            <th>Action Type</th>
            <th>Status</th>
            <th>Date</th>
            <th>User</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
            <ng-container  *ngFor="let item of DataList_Subject">
              <tr >

                <td>{{DataList_Subject.indexOf(item)+1}}</td>
                <td>{{item.dsc}}</td>
                <td>
                  <p *ngIf="item.status" (click)="ChangeStatus(item)" style="color:green ;">Publish</p>
                  <p *ngIf="!item.status" (click)="ChangeStatus(item)" style="color:red ;">Do Not Publish</p>
                </td>
                <td>
                  <p *ngIf="item.type_id==0"  >Routine Action</p>
                  <p *ngIf="item.type_id==1"  style="color:rgb(43, 255, 0) ;">Daily Leave</p>
                  <p *ngIf="item.type_id==2"  style="color:red ;">Initial Scheduling</p>
                  <p *ngIf="item.type_id==3"  style="color:rgb(17, 0, 255) ;">Approve Customer</p>
                  <p *ngIf="item.type_id==4"  style="color:rgb(235, 117, 6) ;">Mission Reservation</p>
                  <p *ngIf="item.type_id==5">Final Approval</p>
                  <p *ngIf="item.type_id==6"  style="color:rgb(99, 101, 105) ;">Certificate Typing</p>
                  <p *ngIf="item.type_id==7">Special Conditions</p>
                </td>
                <td>{{item.persianDate}}</td>
                <td>{{item.creater}}</td>
                <td>
                  <button type="button" (click)="Delete(item)" class="btn btn-danger" style="margin-right: 5px;">
                    <i class="fa  fa-remove"></i> Delete
                  </button>
                </td>
              </tr>
              <tr *ngIf="item.detail.length>0">
                <td colspan="5">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #56399b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>ID</th>
                        <th>Letter Number</th>
                        <th>Customer Name</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Status</th>
                        <th>Last Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  *ngFor="let detail of item.detail">
                        <td>{{item.detail.indexOf(detail)+1}}</td>
                        <td>{{detail.code2}}</td>
                        <td>{{detail.code}}</td>
                        <td>{{detail.customerName}}</td>
                        <td>{{detail.persianDate}}</td>
                        <td>{{detail.clock}}</td>
                        <td>
                          <p *ngIf="detail.coordination==-1" style="color:blue ;">In Progress</p>
                          <p *ngIf="detail.coordination==1" style="color:green ;">Coordinated</p>
                          <p *ngIf="detail.coordination==0" style="color:red ;">Not Coordinated</p>

                          <p *ngIf="detail.done==1" style="color:green ;">Completed</p>
                          <p *ngIf="detail.done==0" style="color:red ;">Not Canceled</p>
                        </td>
                        <td>{{detail.activity_date}}</td>
                      </tr>


                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
        </tbody>
      </table>
    </div>

  </div>
</div>




<ng-template #templateHokem>
  <div class="modal-header">
    <h4 class="modal-title pull-left">System Decree List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Hokem.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Filter_Letter" name="Filter_Letter" type="number" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
              <th>Last Action</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Schedules">
              <td>{{DataList_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>
              <td>
                <p *ngIf="item.coordination==-1" style="color:blue ;">In Progress</p>
                <p *ngIf="item.coordination==1" style="color:green ;">Coordinated</p>
                <p *ngIf="item.coordination==0" style="color:red ;">Not Coordinated</p>

                <p *ngIf="item.done==1" style="color:green ;">Completed</p>
                <p *ngIf="item.done==0" style="color:red ;">Not Canceled</p>
              </td>
              <td>{{item.activity_date}}</td>
              <td>
                <button ype="button" (click)="select_hokem(item)" class="btn btn-info">Select Mission</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_schedule" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_schedule" type="button" (click)="ReadData_Schedules()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Hokem.hide()">Close</button>
  </div>
</ng-template>
